import React from "react";
import { Modal, Typography, Button, Space, Divider, Alert } from "antd";
import { CarOutlined, SafetyCertificateOutlined, AppstoreOutlined, TeamOutlined, CalendarOutlined, ClockCircleOutlined, ArrowRightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { Title, Text } = Typography;

const AdminViewVehicleModal = ({ open, onClose, vehicle }) => {
  if (!vehicle) return null;

  const activeTrip = vehicle.next_assignment;
  const isCurrent = activeTrip && activeTrip.trip_status === 'In Progress';

  const renderRoute = (trip) => {
    if (!trip) return null;
    const from = trip.pickup_venue;
    const to = trip.dropoff_location;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Text strong style={{ fontSize: "16px" }}>{from || "N/A"}</Text>
        <ArrowRightOutlined style={{ color: "#8c8c8c", fontSize: "14px" }} />
        <Text strong style={{ fontSize: "16px" }}>{to || "N/A"}</Text>
      </div>
    );
  };

  return (
    <Modal
      open={open}
      title="Vehicle Details"
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>
      ]}
      className="ouber-modal view-only-modal"
      width={600}
    >
      <div style={{ marginTop: "20px" }}>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          {/* Vehicle Information */}
          <section>
            <Title level={5} className="modal-section-title" style={{ marginTop: 0 }}>Technical Specifications</Title>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
              <div>
                <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>Vehicle Model</Text>
                <div style={{ fontSize: "15px", fontWeight: 500 }}>
                  <CarOutlined style={{ marginRight: "8px", color: "#862633" }} />
                  {vehicle.vehicle_model}
                </div>
              </div>
              <div>
                <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>Plate Number</Text>
                <div style={{ fontSize: "15px" }}>
                  <SafetyCertificateOutlined style={{ marginRight: "8px", color: "#862633" }} />
                  {vehicle.plate_number}
                </div>
              </div>
              <div>
                <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>Vehicle Type</Text>
                <div style={{ fontSize: "15px" }}>
                  <AppstoreOutlined style={{ marginRight: "8px", color: "#862633" }} />
                  {vehicle.vehicle_type}
                </div>
              </div>
              <div>
                <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>Seating Capacity</Text>
                <div style={{ fontSize: "15px" }}>
                  <TeamOutlined style={{ marginRight: "8px", color: "#862633" }} />
                  {vehicle.max_passenger_capacity} Passengers
                </div>
              </div>
            </div>
          </section>

          <Divider style={{ margin: "4px 0" }} />

          {/* Assignment Information */}
          <section>
            <Title level={5} style={{ marginBottom: "12px" }}>{isCurrent ? "Ongoing Assignment" : "Next Scheduled Assignment"}</Title>
            {activeTrip ? (
              <div style={{ background: "#f8f9fa", padding: "12px", borderRadius: "12px", border: "1px solid #f0f0f0" }}>
                <Space direction="vertical" style={{ width: "100%" }} size="small">
                  <div>
                    <Text type="secondary" style={{ display: "block", fontSize: "11px", marginBottom: "2px" }}>Route Details</Text>
                    {renderRoute(activeTrip)}
                  </div>
                  
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
                    {activeTrip.trip_date && (
                      <div>
                        <Text type="secondary" style={{ display: "block", fontSize: "11px" }}>Date</Text>
                        <div style={{ fontSize: "14px" }}>
                          <CalendarOutlined style={{ marginRight: "6px", color: "#862633" }} />
                          {dayjs(activeTrip.trip_date).format("MMMM D, YYYY")}
                        </div>
                      </div>
                    )}
                    <div>
                      <Text type="secondary" style={{ display: "block", fontSize: "12px" }}>Schedule (Pickup - Arrival)</Text>
                      <div style={{ fontSize: "14px" }}>
                        <ClockCircleOutlined style={{ marginRight: "6px", color: "#862633" }} />
                        {activeTrip.pickup_time ? dayjs(activeTrip.pickup_time, "HH:mm:ss").format("h:mm a") : "N/A"} - {activeTrip.estimated_arrival_time ? dayjs(activeTrip.estimated_arrival_time, "HH:mm:ss").format("h:mm a") : "N/A"}
                      </div>
                    </div>
                  </div>
                </Space>
              </div>
            ) : (
              <Alert message="No active or upcoming assignments found for this vehicle." type="info" showIcon />
            )}
          </section>
        </Space>
      </div>
    </Modal>
  );
};

export default AdminViewVehicleModal;
